import { airbnb, binance, coinbase, dropbox, send, shield, star, instagram, facebook, linkedin } from "../assets";

export const navigationLinks = [
  {
    id: "home",
    title: "BoshSahifa",
  },

  {
    id: "praduct",
    title: "Mahsulotlar",
  },

  {
    id: "features",
    title: "Xizmatlar",
  },

  {
    id: "clients",
    title: "Mijozlar",
  },
];

export const statistics = [
  {
    id: 1,
    title: "Foydalanuvchi Faol",
    value: "9300+",
  },

  {
    id: 2,
    title: "Kompaniya Homiylari",
    value: "100+",
  },

  {
    id: 3,
    title: "Tranzaksiya",
    value: "+110M",
  },
];

export const features = [
  {
    id: 1,
    icon: star,
    title: "Muhokamalar qilish",
    content:
      "Eng yahshi kredit kartalari aksiyalar va sovrinlarning ajoyib komninatsiyasi taklif qiladi.",
  },

  {
    id: 2,
    icon: shield,
    title: "100% Himoyalangan",
    content:
      "Ma`lumotlaringiz va tranzaksiyalaringiz xafsiz ekanligini ishonch hosil qilish qilish uchun faol choralar.",
  },

  {
    id: 3,
    icon: send,
    title: "Balansni o`tkazish",
    content:
      "Balansni o`tkazish kredit kartasi sizga foizlarini to`lashga ko`p pul tejash imkinyatini beradi.",
  },
];


export const feedbacks = [
  {
    idx: 1,
    content: "Money is only a tool.It will take you wherever you wish, but it willnot replace you as  the driver",
    name:"Herman Jensen",
    title: "Founder & Leader",
  },

  {
    idx: 2,
    content: "Money makes your life easier.If easer.If you're lucky to have it, you're lucky.",
    name:"Stive Mark",
    title: "Founder & Leader",
  },

  {
    idx: 3,
    content: "It is usually people in the money business, finance, and internatsional that are really rich.",
    name:"Keen Gallagher",
    title: "Founder & Leader",
  },
];

export const clients = [
  {
    id:'client-1',
    logo: airbnb,
  },

  {
    id:'client-2',
    logo: binance,
  },

  {
    id:'client-3',
    logo: coinbase,
  },

  {
    id:'client-4',
    logo: dropbox,
  },
];

export const footerLinks = [
  {
    title:'Jamiyat',
    links:[
      {
        name:'Yordam markazi',
        link: 'https://www.hoobank.com/help-center',
      },

      {
        name:'Hamkorlar',
        link: 'https://www.hoobank.com/partners',
      },

      {
        name:'Takliflar',
        link: 'https://www.hoobank.com/suggestions/',
      },

      {
        name:'Blog',
        link: 'https://www.hoobank.com/blog/',
      },

      {
        name:'Yangiliklar',
        link: 'https://www.hoobank.com/newsletters/',
      },
    ],
  },

  {
    title:'Foydali Havola',
    links: [
      {
        name:'Kontent',
        link: 'https://www.sammi.ac/content/',
      },

      {
        name:'Qanday Ishlaydi',
        link: 'https://www.sammi.ac/how-it-works/',
      },

      {
        name:'Shartlar & xizmatlar',
        link: 'https://www.sammi.ac/terms-and-services/',
      },
    ],
  },

  {
    title:'Hamkor',
    links: [
      {
        name:'Bizning Hamkorimiz',
        link: 'https://www.sammi.ac/our-partner/',
      },

      {
        name:'Hamkor Bo`ling',
        link: 'https://www.sammi.ac/become-a-partner/',
      },

      {
        name:'Shartlar & xizmatlar',
        link: 'https://www.sammi.ac/terms-and-services/',
      },
    ],
  },
];

export const socialMedia = [
  {
    id: 'social-media-1',
    icon: instagram,
    link: 'https://www.instagram.com/doniyorbek077__/',
  },

  {
    id: 'social-media-2',
    icon: facebook,
    link: 'https://www.facebook.com/',
  },

  {
    id: 'social-media-3',
    icon: linkedin,
    link: 'https://www.linkedin.com/in/doniyorbek-tursunov-493204239/',
  },
]